export enum PostalCodesActions {
  ADD = "ADD",
  EDIT = "EDIT",
  DELETE = "DELETE",
  IMPORT = "IMPORT",
}
